import { useState } from "react";
import "../../styles/ComponentStyles/Calendar.css";
import Time from "../timelogic/Time.jsx"; // 👈 Your Time logic

const Calendar = ({ onApply, selectedTime, onTimeSelect , onDateChange }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [currentDate, setCurrentDate] = useState(today);
  const [selectedDate, setSelectedDate] = useState(today);

  const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDay = new Date(year, month, 1).getDay();
  const totalDays = new Date(year, month + 1, 0).getDate();

  const isPastDate = (date) => date < today;

  const prevMonth = () =>
    setCurrentDate(new Date(year, month - 1, 1));

  const nextMonth = () =>
    setCurrentDate(new Date(year, month + 1, 1));

  const formatDate = (date) => {
    const dayName = date.toLocaleDateString("en-US", { weekday: "long" });
    const formattedDate = date.toLocaleDateString("en-GB");
    return `${dayName}, ${formattedDate}`;
  };

  const formattedDateStr = selectedDate.toLocaleDateString("en-GB");
  const totalCells = firstDay + totalDays;
  const rows = Math.ceil(totalCells / 7);
  const cellCount = rows * 7;


  return (
    <div className="calendar-box">
      {/* TOP ROW */}
      <div className="calendar-top">
        <div className="calendar-title">
          Select Date & Time
        </div>

        <div className="calendar-month">
          <button onClick={prevMonth} type="button">‹</button>
          <span>
            {currentDate.toLocaleString("default", { month: "long" })} {year}
          </span>
          <button onClick={nextMonth} type="button">›</button>
        </div>
      </div>

      {/* DAYS */}
      <div className="calendar-days">
        {days.map((d) => (
          <span key={d}>{d}</span>
        ))}
      </div>

      {/* DATES */}
      {/* DATES — FIXED HEIGHT (NO SCROLL, NO JUMP) */}
      <div className="calendar-grid">
        {[...Array(cellCount)].map((_, i) => {
          const dayIndex = i - firstDay + 1;
          const date = new Date(year, month, dayIndex);

          const isCurrentMonth =
            dayIndex > 0 && dayIndex <= totalDays;

          const isPast = isCurrentMonth && isPastDate(date);
          const isSelected =
            isCurrentMonth &&
            date.toDateString() === selectedDate.toDateString();

          return isCurrentMonth ? (
            <button
              key={i}
              className={`${isSelected ? "selected" : ""} ${isPast ? "past-date" : ""
                }`}
              onClick={() => {
                if (isPast) return;
                setSelectedDate(date);
                onDateChange();
              }}
              disabled={isPast}
              type="button"
            >
              {dayIndex}
            </button>
          ) : (
            <span key={i} className="empty-cell" />
          );
        })}
      </div>

     

      {/* TIME SECTION — YOUR LOGIC */}
      <div className="calendar-time-section">
        <Time
          selectedDate={formattedDateStr}
          selectedTime={selectedTime}
          onSelect={onTimeSelect}
        />
      </div>

      {/* ACTION */}
      <div className="calendar-actions">
        <button
          className="apply"
          disabled={!selectedTime} // 👈 Must pick time first
          onClick={() => onApply(selectedDate)}
          type="button"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default Calendar;